import { render } from "./exponent.vue?vue&type=template&id=2c90ac41&scoped=true&ts=true"
import script from "./exponent.vue?vue&type=script&lang=ts"
export * from "./exponent.vue?vue&type=script&lang=ts"

import "./exponent.vue?vue&type=style&index=0&id=2c90ac41&lang=less"
import "./exponent.vue?vue&type=style&index=1&id=2c90ac41&lang=less&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c90ac41"]])

export default __exports__